import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-hot-toast";
import axios from "../../API/axios";
import { people } from "../../config/imagesLink";
import ThemedEmojiPicker from "../../components/ThemedEmojiPicker";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import ErrorToast from "../ErrorToast";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import AddReactionSharpIcon from "@mui/icons-material/AddReactionSharp";
import { Await } from "react-router-dom";
import { useTranslation } from "react-i18next";
const SinglePostComment = ({
  isOwnedPost,
  postId,
  AllPostList,
  AllPostComments,
  setSinglePostCommentList,
  singlepostList,
  setSinglePostList,
  ispostmodalOpen,
  setIspostmodalOpen,
  setPostList,
  videoRef,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  const profilPic = localStorage.getItem("profilPic");
  //************************Post Comment  ************************//
  const [content, setContent] = useState("");
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([])
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const { t } = useTranslation();
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [query, setQuery] = useState(""); // Store the full query
  const [typingTimeout, setTypingTimeout] = useState(null);
  const editorRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [SearchText, setSearchText] = useState("")
  const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");
  const language = localStorage.getItem("Lang");

  const [selectedIndex, setSelectedIndex] = useState(0);
    const suggestionListRef = useRef(null);
  const itemRefs = useRef([]);
  const currentTimeRef = useRef(0);

const saveVideoTime = () => {
  if (videoRef.current) {
    currentTimeRef.current = videoRef.current.currentTime;
  }
};

const restoreVideoTime = () => {
  if (videoRef.current) {
    videoRef.current.currentTime = currentTimeRef.current;
  }
};

  const postData = async () => {
      const formattedComment = updatePostInputValueWithDynamicValues(content, postDynamicValues);

    const postdatadetails = {
      deviceType: "Web",
      sessionId: sessionId,
      postId: postId,
      // comment: postInputValue,
      comment: formattedComment,
      dynamicValues: postDynamicValues,
            langKey: language === "en" ? "" : language,

    };

    if (content.trim() === "") {
      setWarningToastMessage("Please Add the Comment");
      setShowWarningToast(true);
    } else {
      try {
         saveVideoTime();
        const responseData = await axios.post("PostAction/CommentPost", postdatadetails);

        // Normalize API response (handle various shapes)
        const resp = (responseData && responseData.data && (responseData.data.responseData || responseData.data)) || {};
        setContent("");
        setToastMessage(responseData.data?.message || responseData.message || "Comment added");
        setShowToast(true);


        const newComment = {
          pstCmntId: resp?.pstCmntId ?? resp?.pstCommentId ?? resp?.pstCmntId ?? null,
          comment: resp?.comment ?? postInputValue ?? "",
          dynamicValues: resp?.dynamicValues ?? postDynamicValues ?? null,
          likeCount: resp?.likeCount ?? 0,
          replyCount: resp?.replyCount ?? 0,
          isOwned: true,
          isLiked: resp?.isLiked ?? false,
          likedType: resp?.likedType ?? null,
          likedTypeGif: resp?.likedTypeGif ?? null,
          useruid: resp?.useruid ?? localStorage.getItem("userUid") ?? null,
          userName: resp?.userName ?? localStorage.getItem("userName") ?? "",
          userAvatar: profilPic,
          creationTime: resp?.creationTime ?? new Date().toISOString(),
          commentsReplies: resp?.commentsReplies ?? []
        };

        setPostInputValue("");
        setPostDynamicValues([]);

        setSinglePostCommentList((prev = []) => [newComment, ...prev]);

        if (typeof setPostList === "function") {
          setPostList((prevList = []) =>
            prevList.map((post) =>
              post.postInfo?.postId === postId
                ? {
                    ...post,
                    postInfo: {
                      ...post.postInfo,
                      comments: [newComment, ...(Array.isArray(post.postInfo.comments) ? post.postInfo.comments : [])],
                      commentCount: (post.postInfo.commentCount || 0) + 1
                    }
                  }
                : post
            )
          );
        }
        console.log("newcomment", newComment);
        await AllPostComments();
        await AllPostList();
       restoreVideoTime();
      } catch (error) {
        setErrorToastMessage(error.message);
        setShowErrorToast(true);
      }
    }
  };

  // console.log("singlepostList99999999999", singlepostList);

  const handleKeyPress = () => {
    postData();
  };
  const handleEmojiClick = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };
  const handleEmojiClose = () => {
    setShowEmojiPicker(false);
  };
  //************************Post Comment  ************************//
  // Handle typing in textarea
  const handleChange = (e) => {
    const value = e.target.value;
    const caret = e.target.selectionStart;

    setContent(value);
    setCursorPosition(caret);
    detectTrigger(value, caret);

    // Filter out dynamic values no longer in content
    const updatedDynamicValues = postDynamicValues?.filter(({ type, display }) => {
      const prefix = type === "UserMention" || type === "CompanyMention"? "@" : "#";
      const fullMention = `${prefix}${display}`;
      return value.includes(fullMention);
    });

    // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
    const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
      ...item,
      dVno: index + 1
    }));

    setPostDynamicValues(reassignedDynamicValues);

    // Recompute postInputValue
    const updatedPostInputValue = updatePostInputValueWithDynamicValues(value, reassignedDynamicValues);
    setPostInputValue(updatedPostInputValue);
  };

  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    let modifiedText = rawContent;

    dynamicValues.forEach(({ type, dVno, display,displayName }) => {
      const prefix = type === "UserMention" || type === "CompanyMention"? "@" : "#";
      const fullMention = `${prefix}${display || displayName}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    return modifiedText.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q)
    } else {
      // setShowSuggestions(false);
      setSearchText('')
    }
  };
  // const handleTextChange = async (content, delta, source, editor) => {
  //   setContent(content);
  //   const cursorPosition = editor?.getSelection()?.index || 0;

  //   const textBeforeCursor = editor?.getText(0, cursorPosition);
  //   console.log("Text Before Cursor:", textBeforeCursor);

  //   // ✅ Updated regex: capture '@' or '#' followed by 0+ word chars
  //   const match = textBeforeCursor?.match(/([@#])(\w*)$/);
  //   console.log("Match Found:", match);

  //   if (!match) {
  //     setShowSuggestions(false);
  //     return;
  //   }

  //   const triggerChar = match[1]; // '@' or '#'
  //   const query = match[2];       // typed word after trigger
  //   console.log("Detected Trigger:", triggerChar, "Query:", query);

  //   const type = triggerChar === '@' ? "UserMention" : "Hashtag";
  //   setMentionType(type);

  //   // ✅ Only fetch if query length > 0 (after '@' or '#')
  //   if (!query) {
  //     setShowSuggestions(false);
  //     return;
  //   }

  //   // ✅ Debounce fetchSuggestions
  //   if (typingTimeout) clearTimeout(typingTimeout);
  //   const newTimeout = setTimeout(() => {
  //     fetchSuggestions(query, type);
  //   }, 500);
  //   setTypingTimeout(newTimeout);
  // };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      langKey: language === "en" ? "" : language,
      sessionId: sessionId,
    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(`General/MentionTagDDL?Search=${searchText}`, data);
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(`General/HashtagDDL?SearchHashtag=${searchText}`, data);
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      }
    } catch (err) {
      console.error(err);
      if (triggerChar === "#" && searchText) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  useEffect(() => {
    const textarea = document.getElementById("commentTextArea");
    if (textarea) {
      textarea.setSelectionRange(cursorPosition, cursorPosition);
      textarea.focus();
    }
  }, [cursorPosition]);


  const insertMention = (suggestion, userUid,entityType) => {
    const input = editorRef.current;  // Normal input or textarea
    if (!input) return;

    input.focus();

    const cursorPosition = input.selectionStart;
    const textBeforeCursor = input.value.slice(0, cursorPosition);
    const textAfterCursor = input.value.slice(cursorPosition);

    // Match @ or # mention before the cursor
    const match = textBeforeCursor.match(/[@#]\w*$/);
    if (!match) return;

    const startIndex = cursorPosition - match[0].length;
    const finalType = entityType ? entityType : (mentionType === "Hashtag" ? "Hashtag" : "UserMention");

    const mentionPrefix =  mentionType === "Hashtag" ? "#" : "@";
    const displayName = suggestion;
    const mentionText = `${mentionPrefix}${displayName} `;

    // Insert mention at cursor position
    const updatedText =
      textBeforeCursor.slice(0, startIndex) + mentionText + textAfterCursor;

    input.value = updatedText;
    setContent(updatedText);

    const newCursorPosition = startIndex + mentionText.length;

    // Set cursor position after inserted mention
    setTimeout(() => {
      input.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 0);

    // Update dynamic values
    const safePostDynamicValues = Array.isArray(postDynamicValues)
      ? postDynamicValues
      : [];
    //const dVno = safePostDynamicValues.length + 1;

    // const updatedPostDynamicValues = [
    //   ...safePostDynamicValues,
    //   {
    //     type: mentionType,
    //     dVno,
    //     entity: mentionType === "UserMention" ? userUid : suggestion,
    //     display: displayName,
    //   },
    // ];

    const nextDv = {
    type: finalType,
    dVno: safePostDynamicValues.length + 1,
    entity: finalType === "Hashtag" ? displayName : (userUid ?? displayName),
    display: displayName,
  };
  const updatedPostDynamicValues = [...safePostDynamicValues, nextDv];
  const normalized = updatedPostDynamicValues.map((x, i) => ({ ...x, dVno: i + 1 }));
  setPostDynamicValues(normalized);
    // setPostDynamicValues(updatedPostDynamicValues);

    // Replace @mention / #hashtag with {dVno}
    let modifiedText = updatedText;

    updatedPostDynamicValues.forEach(({ type, dVno, display }) => {
      const prefix = type === "Hashtag" ? "#" : "@";
      const fullMention = `${prefix}${display}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    setPostInputValue(modifiedText.trim());
    setShowSuggestions(false);
    setSearchText('')
  };

  // Helper: Escape regex special characters
  const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };
  // console.log('postList', postList);
  const handleKeyDown1 = (e) => {
    if (showSuggestions) {
      const totalItems = mentionType === "Hashtag" ? suggestions.length + 1 : suggestions.length;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev + 1) % totalItems);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev - 1 + totalItems) % totalItems);
      } else if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();

        if (mentionType === "Hashtag" && selectedIndex === 0) {
          insertMention(SearchText, null,null);
        } else {
          const itemIndex = mentionType === "Hashtag" ? selectedIndex - 1 : selectedIndex;
          const selectedItem = suggestions[itemIndex];
          if (selectedItem) {
            insertMention(
              mentionType === "UserMention" ? selectedItem?.entityName : selectedItem?.hashTag,
              mentionType === "UserMention" || selectedItem?.entityType === "CompanyMention"? selectedItem?.userUid : null,
              selectedItem?.entityType,
            );
          }
        }

        setShowSuggestions(false);
        setSelectedIndex(0);
      } else if (e.key === "Escape") {
        setShowSuggestions(false);
      }
    }
  };

  useEffect(() => {
    if (itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    itemRefs.current = [];
    setSelectedIndex(0);
  }, [suggestions]);

  useEffect(() => {
    if (!showSuggestions) {
      setSelectedIndex(0);
    }
  }, [showSuggestions]);
  return (
    <>
      {/* {postList.map((item, index) => {
        return ( */}
      <div className="commentArea">
        <div>
          <img
            // src={item.userAvatar}
            src={profilPic}
            width={35}
            height={35}
            alt=""
            style={{ borderRadius: "50px" }}
          />
        </div>
        <div className="commentBox">
          <input
          style={{
                                direction: language === "ar" ? "rtl" : "ltr",
                                textAlign: language === "ar" ? "right" : "left",  
                              }}
          className="me-2 ps-2"
            ref={editorRef}
            type="text"
            placeholder={t("Newsfeed.Write your comment")}
            value={content}
            onChange={handleChange}
            onKeyDown={handleKeyDown1}
            // onKeyPress={(e) => e.key === "Enter" && handleKeyPress()}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleKeyPress();
              }
            }}
          />
          {showSuggestions && (
            <ul 
              ref={suggestionListRef}
              style={{
              position: "absolute",
              top: "100%",
              left: 0,
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              width: "100%",
              listStyle: "none",
              padding: "5px",
              marginTop: "5px",
              zIndex: 100,
              maxHeight: '250px',
              overflowY: 'auto'
            }}>
              {mentionType === "Hashtag" ? <li
                onMouseDown={(e) => {
                  e.preventDefault(); // Prevent editor blur
                  insertMention(
                    SearchText,
                    null
                  );
                }}
                className="suggestion-item"
              >
                <span>{SearchText ? `#${SearchText}` : ''}</span>
              </li> : null}
              {/* {suggestions.map((item, index) => (
                <li
                  key={index}
                  onMouseDown={(e) => {
                    e.preventDefault(); // Prevent editor blur
                    insertMention(
                      mentionType === "UserMention" ? item?.entityName : item?.hashTag,
                      mentionType === "UserMention" ? item?.userUid : null
                    );
                  }}
                  className="suggestion-item"
                >
                  {mentionType === "UserMention" ? (
                    <>
                      <img
                        src={item?.avatar}
                        alt={item?.entityName}
                        className="avatar"
                      />
                      <span>{item?.entityName}</span>
                    </>
                  ) : (
                    <span>#{item?.hashTag}</span>
                  )}
                </li>
              ))} */}
                {suggestions.map((item, index) => {
                const realIndex = mentionType === "Hashtag" ? index + 1 : index;
                const isActive = selectedIndex === realIndex;

                return (
                <li
                  key={index}
                  ref={(el) => (itemRefs.current[realIndex] = el)}
                  onMouseDown={(e) => {
                    e.preventDefault(); // Prevent editor blur
                    insertMention(
                      mentionType === "UserMention" ? item?.entityName : item?.hashTag,
                      mentionType === "UserMention" || item?.entityType === "CompanyMention" ? item?.userUid : null,
                      item?.entityType,
                    );
                    setShowSuggestions(false);
                  }}
                  className={`suggestion-item ${isActive ? "active" : ""}`}
                >
                  {mentionType === "UserMention" ? (
                    <>
                      <img src={item?.avatar} alt={item?.entityName} className="avatar" />
                      <span>{item?.entityName}</span>
                    </>
                  ) : (
                    <span>#{item?.hashTag}</span>
                  )}
                </li>
                );
              })}
            </ul>
          )}
          <AddReactionSharpIcon
            className="material-symbols-sharp me-2"
            onClick={handleEmojiClick}
            style={{ cursor: "pointer" }}
          />
          <SendSharpIcon
            className="material-symbols-sharp"
            onClick={() => postData()}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div >
      {/* );
      }
      )} */}

      {
        showEmojiPicker && (
          <div className="HuzEmojiPickerChangeColor">
            <ThemedEmojiPicker 
               onEmojiClick={(e, emojiObject) => { 
              const newContent = content + e.emoji;
              setContent(newContent);
              setShowEmojiPicker(false);
                const updatedPostInputValue = updatePostInputValueWithDynamicValues(
                newContent,
                postDynamicValues
              );
              setPostInputValue(updatedPostInputValue);

            }}
            />
            <div
              className="emoji-close"
              onClick={handleEmojiClose}
              style={{ cursor: "pointer" }}
            >
              <CloseSharpIcon className="material-symbols-sharp" />
            </div>
          </div>
        )
      }

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />
      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default SinglePostComment;
